import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
// import { dispatch } from 'redux_data/store';
import { getFirstAndLastDateOfWeek } from 'utils/util'; 

const [start_date , end_date] = getFirstAndLastDateOfWeek();

const slice = createSlice({
  name: 'turboly_sales', // This is the name of the slice
  initialState: {
    hasError: null,
    
    isLoading: false,
    isLoadingDetail: false,
    start_date: start_date, 
    end_date: end_date,
    account_code:"-",
    post_status:"-",
    datas: [],
    data: {},
    cart:[],
    submitData:null,
  },
  reducers: {
    noError(state) { // NO ERROR
      state.isLoading = false;
      state.hasError = false;
    },
    unsetError(state) { // UNSET ERROR
      state.hasError = null;
    },
    hasError(state, action) { // HAS ERROR
      state.isLoading = false;
      state.hasError = JSON.stringify(action.payload);
    },
    
    startLoading: (state, action) => {
      state.isLoading = true;
    },
    startLoadingDetail: (state, action) => {
      state.isLoadingDetail = true;
    },
    setStartDate: (state, action) => {
      state.isLoading = false;
      state.start_date = action.payload;
    },
    setEndDate: (state, action) => {
      state.isLoading = false;
      state.end_date = action.payload;
    },
    setStoreId: (state, action) => {
      state.isLoading = false;
      state.store_id = action.payload;
    },
    setDatas: (state, action) => {
      state.isLoading = false;
      state.datas = action.payload;
    },
    setData: (state, action) => {
      state.isLoadingDetail = false;
      state.data = action.payload;
    },
    setCart: (state, action) => {
      state.cart = action.payload;
    },
    setAccountCode: (state, action) => {
      state.isLoading = false;
      state.account_code = action.payload;
    },
    setPostStatus: (state, action) => {
      state.isLoading = false;
      state.post_status = action.payload;
    },
    setSubmitData: (state, action) => {
      state.submitData = action.payload;
    },
  },
});

export const { 
    noError , 
    unsetError , 
    hasError ,
    setDrawerDetailSales, 
    setDrawerDetailExpense,
    startLoading , 
    startLoadingDetail , 
    setStartDate ,
    setEndDate ,
    setStoreId,
    setDatas , 
    setData ,
    setCart ,
    setAccountCode ,
    setPostStatus ,
    setSubmitData,
} = slice.actions;

export default slice.reducer;

const endpoint = "/turboly_sales"

export function searchData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const state = getState();
      if(!data?.start_date){ data.start_date = state.turboly_sales.start_date} ;
      if(!data?.end_date){ data.end_date = state.turboly_sales.end_date} ;
      // if(!data?.store_id){ data.store_id = state.turboly_sales.store_id} ;
      // console.log({state, data});
      
      let endpointURL = `${endpoint}/search`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("searchData", response);
      if(response?.success){
        dispatch(slice.actions.setDatas(response.data));
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function addData({formData}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      const response = await axios.post(`${endpoint}`, formData )?.then( resp => resp?.data);
      // console.log("addData", response);
      if(response?.success){
        dispatch(noError());
        dispatch(searchData());
      }else{
        dispatch(hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function editData({id, formData, encryptedPin}) {
  return async (dispatch, getState) => {
    dispatch(startLoading());
    try {
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}/${id}`, formData )?.then( resp => resp?.data);
      if(response?.success){
        dispatch(noError());
        dispatch(searchData()); 
      }else{
        dispatch(hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}


export function editDataBulk({ formData}) {
  return async (dispatch , getState) => {
    dispatch(slice.actions.startLoading());
    try {
      // if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.patch(`${endpoint}/bulk`, formData )?.then( resp => resp?.data);
      // console.log("editData", response);
      
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        dispatch(slice.actions.hasError(response));
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function postData({ data = {} , params = {} } = {data: {} , params: {}}) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    try {
      let endpointURL = `${endpoint}/post_sales_data`;
      // let endpointURL = `/marketplace_push_order/post_sales_data`;
      Object.keys(params).forEach(key => {
        if(endpointURL.includes("?")){
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        }else{
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      })
      const response = await axios.post( endpointURL , data )?.then( resp => resp?.data);
      // console.log("postData", response);
      if(response?.success){
        dispatch(slice.actions.noError());
        dispatch(searchData());
      }else{
        if(response?.data){
          dispatch(hasError(response.data));
        }else{
          dispatch(hasError(response));
        }
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function deleteData({item_list, encryptedPin}) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    try {
      // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      const headers = {"headers":{"Content-Type":"multipart/form-data"}}
      if(encryptedPin){ axios.defaults.headers.common.pin = encryptedPin; }
      const response = await axios.put(`${endpoint}`, { item_list } )?.then( resp => { if(resp?.data){ return resp?.data; }else{ console.log(resp?.data); return null; } });
      if(response?.success){
        dispatch(noError());
        dispatch(searchData());
      }else{
        if(response?.data){
          dispatch(hasError(response.data));
        }else{
          dispatch(hasError(response));
        }
      }
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  };
}

export function setDetail(data) {
  return async (dispatch, getState) => {
    // console.log("setDetail" , data);
    dispatch(startLoadingDetail());
    try {
      dispatch(setData(data))
    } catch (error) {
      if(error?.response?.data){
        dispatch(hasError(error.response.data));
      }else if(error?.message){
        dispatch(hasError(error.message));
      }else{
        dispatch(hasError(error));
      }
    }
  }
}

// export function setCart(data) {
//   return async () => {
//     try {
//       dispatch(slice.actions.setCart(data))
//     } catch (error) {
//       console.log(error);
//     }
//   }
// }
